import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function createDraftItem(currentUser: string | null, ttlMs: number): Promise<string> {
  const payload = {
    isDraft: true,
    wizardStep: 1,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    createdBy: currentUser,
    completed: false,
    photos: {},
    expiresAt: new Date(Date.now() + ttlMs),
    auditLog: [
      { action: "draft-created", by: currentUser, at: new Date().toISOString() },
    ],
  };

  try {
    console.info("[Draft] create payload", payload);
    (window as any).__LAST_DRAFT_PAYLOAD__ = payload;
  } catch { /* ignore */ }

  const refDoc = await addDoc(collection(db, "itInventory"), payload);
  return refDoc.id;
}

export async function patchDraftItem(draftId: string, patch: any): Promise<void> {
  await updateDoc(doc(db, "itInventory", draftId), {
    ...patch,
    updatedAt: serverTimestamp(),
  } as any);
}
